/* 共通 */
import './_initializeSmoothScroll.js';
import './_drawer.js';
import './_toggle.js';
import './_page-top.js';
import './_fadein.js';
import './_header.js';


/* 無限ループスライダー */
import './_splide-loop.js';
import './_splide-thumbnail.js';
import './_splide-about-activity.js';


/* モーダル */
// import './_dialog-common.js'; // _dialog-generalから読み込んでいるため、ここでは読み込み不要
import './_dialog-general.js'; // _splide-loop.js後に読み込む（スライ後の複製を待つ必要あり）
import './_dialog-video.js';


/* カウントアップ */
import './_counter.js';

/* タブ */
import './_tab.js';

/* アコーディオン */
import './_accordion.js';

/* Facebookプラグイン */
import './_facebook.js';

/* メールアドレス保護 */
import './_email-protection.js';

/* スクロールヒント */
import './_scroll-hint.js';

/* インタビューアーカイブ もっと見る */
import './_archive-interview-load-more.js';